
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">
    {{ ledger?.name }}
  </h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="ledger">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!ledger.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  
  <div *ngIf="mode === 'view'" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="ledger">

    <div class="column">

      <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
        <h2>Registre</h2>

        <div class="form-group" [formGroup]="formGroup">
          <label for="name">Nom</label>

          <t-option *ngIf="ledgerTemplates.length > 0" [options]="nameSourceOptions" [(value)]="nameSource"></t-option>

          <select *ngIf="nameSource === 'SELECT'" formControlName="templatesSelect">
            <option *ngFor="let opt of ledgerTemplates" [ngValue]="opt">{{ opt.name }}</option>
          </select>

          <ng-container *ngIf="nameSource === 'OTHER'">
            <input #nameInput id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
            <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
          </ng-container>
        </div>

        <div *ngIf="mode === 'new'" class="form-group">
          <label>Avec documents signés</label>
          <t-option [(value)]="ledger.signed"></t-option>
        </div>

        <div *ngIf="mode === 'edit'" class="form-group">
          <label>Avec documents signés</label>
          <span class="value">{{ ledger.signed | yesno }}</span>
        </div>

      </div>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Registre</h2>
      
        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ ledger.name }}</span>
        </div>

        <div class="form-group">
          <label>Avec documents signés</label>
          <span class="value">{{ ledger.signed | yesno }}</span>
        </div>

      </div>
      
    </div>
    
    <div class="column">

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Liste des documents</h2>
      
        <div class="btn-toolbar">

          <a class="btn btn-small btn-gray" [routerLink]="['edit-documents']" title="Modifier la liste des documents">
            <t-icon name="list_edit"></t-icon>
            <span class="text">Modifier</span>
          </a>

          &nbsp;

          <a *ngIf="ledger.documents.length > 0" class="btn btn-small btn-gray" title="Télécharger tous les documents" href="/files/documents-ledger/document/{{ company.id }}/{{ ledger.id }}">
            <t-icon name="file_download"></t-icon>
            <span class="text">Télécharger</span>
          </a>

        </div>
      
        <table class="attachments">
          <tbody>
            <tr *ngFor="let document of ledger.documents">
              
              <!--Details-->
              <td>
                {{ document.filename }}
        
                <div class="item-details">
                  <div>
                    <label>Commentaire</label>
                    <span>{{ document.comment | empty }}</span>
                  </div>

                  <div>
                    <label>Date</label>
                    <span>{{ document.date | documentdate }}</span>
                  </div>

                  <div>
                    <label>Taille</label>
                    <span>{{ document.filesize | filesize }}</span>
                  </div>
                </div>
        
              </td>
        
              <td style="width: 50px;" class="actions">
                <a class="action-btn" href="/files/documents-ledger/document/{{ company.id }}/{{ ledger.id }}/{{ document.id }}">
                  <t-icon name="file_download"></t-icon>
                </a>
              </td>
        
            </tr>
          </tbody>
        </table>
      
        <div class="empty-table compact" *ngIf="ledger.documents.length === 0">
          <p>Aucun document dans ce registre</p>
        </div>
      
      </div>

    </div>

  </div>
</form>